import React from 'react'
import { ShellRootComponentProps } from 'src/types/shell'
import Template from '../root.component'
import { AppWrapper } from '../../hpallin-device-onboarding/index'

export default function Root({
  useToast,
  properties,
  onMount,
  onUnmount
}: ShellRootComponentProps) {
  const appComponent = <AppWrapper />
  return (
    <Template {...{ useToast, properties, onMount, onUnmount, appComponent }} />
  )
}
